import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем interceptor для добавления токена
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth endpoints
export const authApi = {
  register: (data) => api.post('/users', data),
  login: (data) => api.post('/auth/login', data),
  getUsers: () => api.get('/users'),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  me: () => api.get('/auth/me'),
};

// Tickets endpoints
export const ticketsApi = {
  getAll: () => api.get('/tickets'),
  getOne: (id) => api.get(`/tickets/${id}`),
  create: (data) => {
    const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    return api.post('/tickets', data, config);
  },
  update: (id, data) => {
    const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    return api.put(`/tickets/${id}`, data, config);
  },
  delete: (id) => api.delete(`/tickets/${id}`),
  addComment: (ticketId, data) => {
    const config = data instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    return api.post(`/tickets/${ticketId}/comments`, data, config);
  },
  editComment: (commentId, data) => {
    // Добавляем поддержку удаления вложений
    return api.put(`/tickets/comments/${commentId}`, data);
  },
};

// Base URL for direct links to server (without /api)
export const BASE_URL = API_URL.replace('/api', '');

// Files endpoints
export const filesApi = {
  getFileUrl: (id) => api.get(`/files/${id}`),
};

// Projects endpoints
export const projectsApi = {
  getAll: () => api.get('/projects'), // только для админа
  create: (data) => api.post('/projects', data), // только для админа
  update: (id, data) => api.put(`/projects/${id}`, data), // только для админа
  delete: (id) => api.delete(`/projects/${id}`), // только для админа
  getById: (id) => api.get(`/projects/${id}`),
  getUserProjects: () => api.get('/projects/user/list'),
  assignUser: (userId, projectId) => api.post('/projects/assign', { userId, projectId }), // только для админа
  removeUser: (userId, projectId) => api.post('/projects/remove', { userId, projectId }), // только для админа
  setCurrent: (projectId) => api.post('/projects/current', { projectId }),
  getCurrent: () => api.get('/projects/current'),
  getProjectUsers: (projectId) => api.get(`/projects/${projectId}/users`),
};

// Custom fields endpoints
export const customFieldsApi = {
  getProjectFields: (projectId) => api.get(`/custom-fields/project/${projectId}`),
  create: (projectId, data) => api.post(`/custom-fields/project/${projectId}`, data),
  update: (fieldId, data) => api.put(`/custom-fields/${fieldId}`, data),
  delete: (fieldId) => api.delete(`/custom-fields/${fieldId}`),
  reorder: (projectId, fieldOrder) => api.put(`/custom-fields/project/${projectId}/reorder`, { fieldOrder }),
  getTicketValues: (ticketId) => api.get(`/custom-fields/ticket/${ticketId}/values`),
  searchFieldValues: (projectId, fieldName, query) => api.get(`/custom-fields/project/${projectId}/field/${fieldName}/search?q=${encodeURIComponent(query)}`)
};
